import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { LoginMobileComponent } from './login-mobile/login-mobile.component';
import { WorkspaceMobileComponent } from './workspace-mobile/workspace-mobile.component';
import { LoginAcccountComponent } from './login-acccount/login-acccount.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { FormPageComponent } from './form-page/form-page.component';

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'landing-page',
        component: LandingPageComponent
    },
    {
        path: 'form-page',
        component: FormPageComponent
    },

    {
        path: 'signup',
        component: SignupComponent
    },
    {
        path: 'reset-password',
        component: PasswordresetComponent
    },
    {
        path: 'workspace',
        component: WorkspaceComponent
    },
    {
        path: 'workspace-mobile',
        component: WorkspaceMobileComponent
    },
    {
        path: 'login-mobile',
        component: LoginMobileComponent
    },
    {
        path: 'login-account',
        component: LoginAcccountComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
